import { Flex, Text } from '@mantine/core';
import { ErrorCode, VoucherAllowanceStatus } from '@web/common';
import { Card } from '../../../../../component';
import { observer } from 'mobx-react';
import classes from './QuestionnaireItem.module.css';
import { useVoucherStateStore } from '../stores/VoucherStateStore';
import { COLORS } from './constants';
import { RedeemButton, RedeemedVouchers } from './VoucherStates';
import { useTranslation } from 'react-i18next';
import {
  showErrorNotification,
  showSuccessNotification,
} from '../../../../../component/notification';
import { MyIcon } from '@web/common-ui';

export const BmsSampleVoucherItem = observer(() => {
  const store = useVoucherStateStore();
  const { t } = useTranslation('questionnaire');
  const { bmsSampleVoucherStatus } = store;

  if (!bmsSampleVoucherStatus) return null;

  const handleRedeemVoucher = () => {
    if (
      bmsSampleVoucherStatus.type ===
      VoucherAllowanceStatus.AvailableToBeRedeemed
    ) {
      store.redeemVoucher(
        bmsSampleVoucherStatus.voucherAllowanceId,
        () => showSuccessNotification(t('RedeemVoucherSuccess')),
        () => showErrorNotification(ErrorCode.CannotRedeemVoucher),
      );
    }
  };

  const renderVoucherContent = () => {
    switch (bmsSampleVoucherStatus.type) {
      case VoucherAllowanceStatus.AvailableToBeRedeemed:
        return <RedeemButton onRedeem={handleRedeemVoucher} />;
      case VoucherAllowanceStatus.Redeemed:
        return <RedeemedVouchers vouchers={bmsSampleVoucherStatus.vouchers} />;
    }
  };

  return (
    <Card
      className={classes.card}
      flexProps={{ align: 'start', direction: 'column' }}
    >
      <Flex direction="row" justify="space-between" align="center" w="100%">
        <Flex direction="row" align="center" justify="center" gap="1em">
          <MyIcon name="questionnaire" />
          <Flex direction="column">
            <Text fw={700} size="16px" lh="24px" c={COLORS.TEXT_PRIMARY}>
              {t('BmsSample.Title')}
            </Text>
          </Flex>
        </Flex>
      </Flex>

      {renderVoucherContent()}
    </Card>
  );
});
